import Vue from 'vue'
import Router from 'vue-router'
import utils from '@utils'

Vue.use(Router)

// let listt=location.href.split('=');
// let strt=listt[listt.length-1];

let locationhref=location.href;
let brand=utils.BIPtools.getBIP(locationhref).brand;
let industry=utils.BIPtools.getBIP(locationhref).industry;
let productCode=utils.BIPtools.getBIP(locationhref).productCode;
let appParams=utils.BIPtools.getBIP(locationhref).appParams;

const router = new Router({
  mode:'history',
  base:'app',
  // 卡萨帝	casarte
  // 海尔	haier
  // 统帅	leader

  // 商用空调	BAC
  // 冷柜	FRE
  // 家用空调	HAC
  // 厨电	KIT
  // 冰箱	REF
  // 洗涤	WAS
  // 热水器	WAT

  routes: [
    // 最终统一配置
    {
      path: `/${brand}/${industry}`,
      name: `HomePage`,
      component: () => import(`@/components/${brand}/${industry}/HomePage`),
      meta: {
        keepAlive: true // 此组件需要被缓存
      }
    }, {
      path: `/${brand}/${industry}/subPage/TabsPage/?${appParams}`,
      name: `${brand}${industry}TabsPage`,
      component: () => import(`@/components/${brand}/${industry}/subPage/hasTabs/TabsPage`)
    }, {
      path: `/${brand}/${industry}/subPage/SimplePage/?${appParams}`,
      name: `${brand}${industry}SimplePage`,
      component: () => import(`@/components/${brand}/${industry}/subPage/noTabs/SimplePage`)
    },
    {path:'/*',redirect:`/${brand}/${industry}`}
    // 本地调试
    // 卡萨帝冰箱
    // {
    //   path: '/casarte/REF',
    //   name: 'HomePage',
    //   component: () => import('@/components/casarte/REF/HomePage'),
    //   meta: {
    //     keepAlive: true // 此组件需要被缓存
    //   }
    // }, {
    //   path: `/casarte/REF/subPage/TabsPage/?productCode=${productCode}`,
    //   name: 'TabsPage',
    //   component: () => import('@/components/casarte/REF/subPage/hasTabs/TabsPage')
    // }, {
    //   path: `/casarte/REF/subPage/SimplePage/?productCode=${productCode}`,
    //   name: 'SimplePage',
    //   component: () => import('@/components/casarte/REF/subPage/noTabs/SimplePage')
    // },
    // 卡萨帝空调
    // {
    //   path: '/casarte/HAC',
    //   name: 'HomePage1',
    //   component: () => import('@/components/casarte/HAC/HomePage'),
    //   meta: {
    //     keepAlive: true // 此组件需要被缓存
    //   }
    // }, {
    //   path: `/casarte/HAC/subPage/TabsPage/?productCode=${productCode}`,
    //   name: 'TabsPage1',
    //   component: () => import('@/components/casarte/HAC/subPage/hasTabs/TabsPage')
    // }, {
    //   path: `/casarte/HAC/subPage/SimplePage/?productCode=${productCode}`,
    //   name: 'SimplePage1',
    //   component: () => import('@/components/casarte/HAC/subPage/noTabs/SimplePage')
    // },
    //卡萨帝洗衣机
    // {
    //   path: '/casarte/WAS',
    //   name: 'HomePage2',
    //   component: () => import('@/components/casarte/WAS/HomePage'),
    //   meta: {
    //     keepAlive: true // 此组件需要被缓存
    //   }
    // }, {
    //   path: `/casarte/WAS/subPage/TabsPage/?productCode=${productCode}`,
    //   name: 'TabsPage2',
    //   component: () => import('@/components/casarte/WAS/subPage/hasTabs/TabsPage')
    // }, {
    //   path: `/casarte/WAS/subPage/SimplePage/?productCode=${productCode}`,
    //   name: 'SimplePage2',
    //   component: () => import('@/components/casarte/WAS/subPage/noTabs/SimplePage')
    // },
    // 卡萨帝厨电
    // {
    //   path: '/casarte/KIT',
    //   name: 'casarteKITHomePage',
    //   component: () => import('@/components/casarte/KIT/HomePage'),
    //   meta: {
    //     keepAlive: true // 此组件需要被缓存
    //   }
    // }, {
    //   path: `/casarte/KIT/subPage/TabsPage/?productCode=${productCode}`,
    //   name: 'casarteKITTabsPage',
    //   component: () => import('@/components/casarte/KIT/subPage/hasTabs/TabsPage')
    // }, {
    //   path: `/casarte/KIT/subPage/SimplePage/?productCode=${productCode}`,
    //   name: 'casarteKITSimplePage',
    //   component: () => import('@/components/casarte/KIT/subPage/noTabs/SimplePage')
    // },
     // 海尔空调
    // {
    //   path: '/haier/HAC',
    //   name: 'haierHomePage',
    //   component: () => import('@/components/haier/HAC/HomePage'),
    //   meta: {
    //     keepAlive: true // 此组件需要被缓存
    //   }
    // }, {
    //   path: `/haier/HAC/subPage/TabsPage/?productCode=${productCode}`,
    //   name: 'haierTabsPage',
    //   component: () => import('@/components/haier/HAC/subPage/hasTabs/TabsPage')
    // }, {
    //   path: `/haier/HAC/subPage/SimplePage/?productCode=${productCode}`,
    //   name: 'haierSimplePage',
    //   component: () => import('@/components/haier/HAC/subPage/noTabs/SimplePage')
    // },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js